<template>
  <el-main class="main_content" style="padding: 0">
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="backList">代理申请管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>修改代理申请记录</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns1">
        <li>
          <el-button @click="backList" type="primary">返回代理申请管理</el-button>
        </li>
      </ul>
      <div class="contain_header1 clr">
        <el-form
          style="width:850px;"
          ref="form"
          :model="form"
          label-width="200px"
          :rules="addFormRule"
        >
          <el-form-item label="店铺名称" prop="showName">
            <el-input v-model="form.showName" style="width:70%"></el-input>
          </el-form-item>

          <el-form-item label="店铺联系方式" prop="storeTel">
            <el-input v-model="form.storeTel" style="width:70%"></el-input>
          </el-form-item>
          <!--
          <el-form-item
            label="代理类型"
            prop="roleType"
          >
            <el-select
              v-model="form.roleType"
              placeholder="请选择"
            >
              <el-option
                v-for="option in typeOptions"
                :value="option.value"
                :key='option.value'
                :label="option.text"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="特殊身份"
            prop="special_status"
          >
            <el-select
              v-model="form.special_status"
              placeholder="请选择"
            >
              <el-option
                v-for="option in specialOptions"
                :value="option.value"
                :key='option.value'
                :label="option.text"
              ></el-option>
            </el-select>
          </el-form-item>-->

          <el-form-item label="保证金" v-if="form.roleType == 4.2" prop="deposit">
            <el-input
              :disabled="form.status != 0"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.deposit"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item label="学习费" prop="send_integral">
            <el-input
              :disabled="!((form.roleType == 4.2 && form.status == 5) || (form.roleType != 4.2 && form.status == 9))"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.send_integral"
              style="width:68%"
            ></el-input>
            <el-tooltip  effect="dark" content='已交过学习费（等级是4.2后台审核通过、其他等级 待付学习费）的才可以填写'>
              <i class="el-icon-question"/>
            </el-tooltip>
          </el-form-item>

          <el-form-item label="购物金额" prop="payMoney">
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.payMoney"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item label="所在省" prop="province">
            <el-select v-model="form.province" placeholder="请选择" @change="changeCity">
              <el-option
                v-for="option in provinceOptions"
                :value="option"
                :key="option"
                :label="option"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="所在市" prop="city">
            <el-select v-model="form.city" placeholder="请选择" @change="changeDistrict">
              <el-option
                v-for="option in cityOptions"
                :value="option"
                :key="option"
                :label="option"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="所在区" prop="district">
            <el-select v-model="form.district" placeholder="请选择">
              <el-option
                v-for="option in districtOption"
                :value="option"
                :key="option"
                :label="option"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="省代类型" v-if="form.roleType == 3" prop="deposit">
            <el-select
                  clearable
                  v-model="form.province_type"
                  placeholder="请选择"
                >
                  <el-option
                    label="优秀省代"
                    value="1"
                  ></el-option>
                  <el-option
                    label="战略省代"
                    value="2"
                  ></el-option>


                </el-select>
          </el-form-item>

          <div v-if="form.roleType >= 0" style="display:flex;">
            <el-form-item label="门店地址" prop="longitude">
              <el-input id="tipinput" v-model="form.addressDetail"></el-input>

              <div class="amap-wrapper2" id="container" tabindex="0"></div>
            </el-form-item>

            <div style="margin-left:20px;">
              <el-button
                :loading="searchAddByWordLoading"
                @click="searchAddByWord"
                size="small"
                type="primary"
              >搜索</el-button>
              <div style="margin-top: 5px;height: 500px;overflow-y: auto;">
                <div
                  v-bind:class="{choosedLi:showItemIndex==index}"
                  @click="showItem(item, index)"
                  v-for="(item, index) in searchList"
                  v-bind:key="index"
                  style="width:250px;padding:10px 5px;display:flex;flex-direction: column;cursor: pointer;"
                >
                  <span>地址信息：{{item.formatted_address}}</span>
                  <span>坐标：{{item.location}}</span>
                  <span>省市：{{item.country}}{{item.city}}{{item.district}}</span>
                </div>
              </div>
            </div>
          </div>

          <el-form-item style="margin-top:60px">
            <el-button type="primary" @click="onSubmit('form')" :loading="addLoading">{{wordName}}</el-button>
            <el-button @click="resetForm('form')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </el-main>
</template>

<script>
import AMap from "AMap";
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc.js";
var _ = require("lodash");
export default {
  name: "editUpLog",
  data() {
    return {
      searchAddByWordLoading: false,
      options: [
        { text: "显示", value: "1" },
        { text: "不显示", value: "0" }
      ],
      specialOptions: [
        { text: "不是", value: "1" },
        { text: "是", value: "2" }
      ],
      typeOptions: [
        { text: "康减系列vip会员", value: "-0.5" },
        { text: "康减系列高级会员", value: "-0.4" },
        { text: "康减系列荣誉会员", value: "-0.3" },
        { text: "康减系列市代", value: "1.1" },
        { text: "康减系列省代", value: "2.1" },
        { text: "康减系列CEO", value: "3.1" },
        { text: "VIP门店", value: "0" },
        { text: "联盟店", value: "1" },
        { text: "优秀联盟店", value: "1.05" },
        { text: "市代", value: "2" },
        { text: "省代", value: "3" },
        { text: "CEO", value: "4" },
        { text: "总经销商", value: "5" },{ text: "合伙人", value: "2.2" },{ text: "董事", value: "4.2" },{ text: "经销商", value: "4.8" },{ text: "区域总监", value: "5.1" },{ text: "城市加盟商", value: "5.2" }
      ],
      provinceOptions: [],
      showItemIndex: null,
      cityOptions: [],
      searchList: [],
      districtOption: [],
      tokenData: {
        token: localStorage.getItem("api_token")
      },
      good: null,
      wordName: "新增",
      addFormRule: {

      },
      addLoading: false,
      map: null,
      marker: null,
      auto: null,
      form: {
        payMoney:null,
        showName: null,
        special_status: "1",
        province_type:null,
        storeTel: null,
        longitude: null,
        latitude: null,
        addressDetail: null,
        province: null,
        city: null,
        district: null,
        username: null,
        telephone: null,
        realName: null,
        idFront: null,
        id: null,
        idBack: null,
        idCode: null,
        userHead: "https://vedio.hkymr.com/kefuPic.png",
        balance: 0,
        deposit: 0,
        send_integral: 0,
        roleType: "0",
        status: "0",
        sex: "1",
        recommendCode: null
      }
    };
  },
  mounted(e) {
    //初始化表单
    var that = this;
    this.loadmap();
    API.get_province({ token: localStorage.getItem("api_token") })
      .then(
        function(result) {
          if (result.key == 1000) {
            that.provinceOptions = result.result.list;
          } else if (result.key == 1001) {
            bus.$emit("goto", "/login");
          } else {
            that.$message.error({
              showClose: true,
              message: result.message || "登录失败",
              duration: 2000
            });
          }
        },
        function(err) {
          console.error(err);
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        console.error(error);
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
    var good = this.$route.query.good;
    that.good = good;
    var para = {
      id: that.$route.query.id,
      token: localStorage.getItem("api_token")
    };
    if (good != null) {
      that.wordName = "修改";
      that.form.id = good.id;
      if (good.store_info && good.store_info != null && good.store_info != "") {
        that.form.store_info = JSON.parse(good.store_info);
        that.form.showName = that.form.store_info.showName;
        that.form.storeTel = that.form.store_info.telephone;
        that.form.longitude = that.form.store_info.longitude;
        that.form.latitude = that.form.store_info.latitude;
        that.form.addressDetail = that.form.store_info.addressDetail;
        if (that.form.longitude != null) {
          var lng = that.form.longitude;
          var lat = that.form.latitude;
          if (this.marker != null) {
            this.marker.setMap(null);
            this.marker = null;
          }
          this.marker = new AMap.Marker({
            // icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
            position: [lng, lat],
            offset: new AMap.Pixel(-13, -30),
            clickable: true
          });
          this.marker.setMap(this.map);
          var lng = lng; //经度范围[121.138398, 121.728226]
          var lat = lat; //纬度范围[30.972688, 31.487611]
          this.map.setCenter([lng, lat]); //设置地图中心点
          var clickHandle = AMap.event.addListener(
            this.marker,
            "click",
            function(e) {}
          );
        }
      }
      that.form.roleType = good.role_type;
      that.form.status = good.status;
      that.form.deposit = good.deposit;
      that.form.payMoney = good.pay_money;
      that.form.province = good.province;
      that.form.city = good.city;
      that.form.district = good.district;
      that.form.send_integral = good.send_integral;
      console.log(good)
    } else {
      that.form.info_type = "1";
      that.wordName = "立即创建";
    }
  },
  computed: {},
  methods: {
    showItem(item, index) {
      this.showItemIndex = index;
      var loc = item.location.split(",");
      var lng = loc[0];
      var lat = loc[1];
      if (this.marker != null) {
        this.marker.setMap(null);
        this.marker = null;
      }
      // console.info(e);
      this.marker = new AMap.Marker({
        // icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
        position: [lng, lat],
        offset: new AMap.Pixel(-13, -30),
        clickable: true
      });
      this.marker.setMap(this.map);
      var lng = lng; //经度范围[121.138398, 121.728226]
      var lat = lat; //纬度范围[30.972688, 31.487611]
      this.map.setCenter([lng, lat]); //设置地图中心点
      var clickHandle = AMap.event.addListener(this.marker, "click", function(
        e
      ) {});
      this.form.latitude = lat;
      this.form.longitude = lng;
    },
    searchAddByWord() {
      if (this.form.addressDetail != null && this.form.city != null) {
        var that = this;
        that.searchAddByWordLoading = true;
        API.select_address_by_word({
          token: localStorage.getItem("api_token"),
          word: this.form.addressDetail,
          city: this.form.city
        })
          .then(
            function(result) {
              if (result.key == 1000) {
                that.searchList = result.result.list;
              } else if (result.key == 1001) {
                bus.$emit("goto", "/login");
              } else {
                that.$message.error({
                  showClose: true,
                  message: result.message || "登录失败",
                  duration: 2000
                });
              }
              that.searchAddByWordLoading = false;
            },
            function(err) {
              that.searchAddByWordLoading = false;
              console.error(err);
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.searchAddByWordLoading = false;
            console.error(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      } else {
        this.$message.error({
          showClose: true,
          message: "请选择所在城市和填写要搜索的地址",
          duration: 2000
        });
      }
    },
    loadmap() {
      this.map = new AMap.Map("container", {
        zoom: 9
      });
      var options = {
        input: "tipinput"
      };
      if (this.form.city != null) {
        options.city = this.form.city;
      }
      this.auto = new AMap.Autocomplete(options);
      var placeSearch = new AMap.PlaceSearch({
        map: this.map
      }); //构造地点查询类
      AMap.event.addListener(this.auto, "select", this.select); //注册监听，当选中某条记录时会触发
    },
    select(e) {
      if (this.marker != null) {
        this.marker.setMap(null);
        this.marker = null;
      }
      // console.info(e);
      this.marker = new AMap.Marker({
        // icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
        position: [e.poi.location.lng, e.poi.location.lat],
        offset: new AMap.Pixel(-13, -30),
        clickable: true
      });
      this.marker.setMap(this.map);
      var lng = e.poi.location.lng; //经度范围[121.138398, 121.728226]
      var lat = e.poi.location.lat; //纬度范围[30.972688, 31.487611]
      this.map.setCenter([lng, lat]); //设置地图中心点
      var clickHandle = AMap.event.addListener(this.marker, "click", function(
        e
      ) {
        console.info(e);
      });
      this.form.latitude = e.poi.location.lat;
      this.form.longitude = e.poi.location.lng;
    },
    changeCity() {
      if (this.form.province != null) {
        var that = this;
        API.get_city({
          token: localStorage.getItem("api_token"),
          province: this.form.province
        })
          .then(
            function(result) {
              if (result.key == 1000) {
                that.cityOptions = result.result.list;
              } else if (result.key == 1001) {
                bus.$emit("goto", "/login");
              } else {
                that.$message.error({
                  showClose: true,
                  message: result.message || "登录失败",
                  duration: 2000
                });
              }
            },
            function(err) {
              console.error(err);
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            console.error(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      }
    },
    changeDistrict() {
      if (this.form.city != null) {
        if (this.form.city != null) {
          this.auto.setCity(this.form.city);
        }
        // var auto = new AMap.Autocomplete(options);

        // var placeSearch = new AMap.PlaceSearch({
        //   map: this.map
        // }); //构造地点查询类
        // AMap.event.addListener(auto, "select", this.select); //注册监听，当选中某条记录时会触发
        var that = this;
        API.get_district({
          token: localStorage.getItem("api_token"),
          city: this.form.city
        })
          .then(
            function(result) {
              if (result.key == 1000) {
                that.districtOption = result.result.list;
              } else if (result.key == 1001) {
                bus.$emit("goto", "/login");
              } else {
                that.$message.error({
                  showClose: true,
                  message: result.message || "登录失败",
                  duration: 2000
                });
              }
            },
            function(err) {
              console.error(err);
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            console.error(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      }
    },
    beforeAvatarUpload: function(e) {},
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.userHead = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccess1: function(e) {
      if (e.key == 1000) {
        this.form.idFront = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccess2: function(e) {
      if (e.key == 1000) {
        this.form.idBack = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    backList() {
      this.$router.push({
        path: "/up_group_list"
      });
    },

    onSubmit() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = {
            id: that.form.id,
            province: that.form.province,
            showName: that.form.showName,
            telephone: that.form.storeTel,
            longitude: that.form.longitude,
            latitude: that.form.latitude,
            addressDetail: that.form.addressDetail,
            city: that.form.city,
            provinceType:that.form.province_type,
            sendIntegral:that.form.send_integral,
            district: that.form.district,
            deposit: that.form.deposit,
            payMoney: that.form.payMoney
          };
          para.token = localStorage.getItem("api_token");

          that.addLoading = true;
          API.do_up_role_up(para)
            .then(
              function(result) {
                that.addLoading = false;
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "修改成功",
                    duration: 1500
                  });
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.loading = false;
                console.error(err);
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              console.error(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },
    jumpTo(url) {
      this.defaultActiveIndex = url;
      this.$router.push(url); //用go刷新
    },
    resetForm() {
      let that = this;
      that.$refs["form"].resetFields();
    }
  }
};
</script>

<style>
.el-tooltip__popper {
  max-width: 800px;
  font-size: 14px !important;
  line-height: 20px !important;
  background-color: #333 !important;
  color: #fff !important;
}
.choosedLi {
  background-color: coral;
}
.amap-wrapper2 {
  width: 600px;
  height: 500px;
}
.area-select .area-selected-trigger {
  padding: 0px 20px 7px 12px;
  line-height: 40px;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}
.cont_btns1 {
  float: left;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns1 li {
  display: inline-block;
}
.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}

.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}

.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}

.contain_div {
  margin: 20px;
}

.contain_header1 {
  background-color: #fff;
  padding: 40px 0 20px 40px;
  /* margin-bottom: 20px; */
}

.area-select {
  height: 40px;
}

.area-select-wrap .area-select {
  margin-left: 0px !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/user/editUpLog.vue